export default "__VITE_PUBLIC_ASSET__8bfb01f2__"